"use client";
import React from "react";
import { usePathname } from "next/navigation";
import Sidebar from "./sidebar";
import Header from "./header";
import PlanGate from "@/components/auth/PlanGate";

const HIDE_CHROME_ON = new Set<string>([
  "/", // página de inicio (sin sidebar ni navbar)
]);

/** Prefixes where the POS chrome (sidebar+header) should NOT render */
const HIDE_CHROME_PREFIX = ["/platform", "/auth", "/onboarding"];

export default function AppShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  // Sin sidebar ni navbar en rutas exactas
  if (HIDE_CHROME_ON.has(pathname)) {
    return <div className="min-h-screen bg-gray-50">{children}</div>;
  }

  // Sin sidebar ni navbar en platform / auth / onboarding (tienen su propio shell)
  if (HIDE_CHROME_PREFIX.some((p) => pathname.startsWith(p))) {
    return <>{children}</>;
  }

  // Con sidebar + header + PlanGate para el resto
  // PlanGate envuelve {children} y valida si el plan permite ver el contenido.
  // Si no tiene acceso, muestra un wall de upgrade en lugar de la info.
  return (
    <div className="min-h-screen flex">
      <Sidebar />
      <main className="flex min-w-0 flex-1 flex-col overflow-x-hidden">
        <Header />
        <PlanGate>
          <div className="min-w-0 overflow-x-hidden">{children}</div>
        </PlanGate>
      </main>
    </div>
  );
}
